module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (182).85c87029.jpg";